<template>
  <ion-page>
    <Background></Background>
    <SidebarBackground></SidebarBackground>
    <WhiteBackground half="true"></WhiteBackground>
    <FabColumn>
      <LogoutButton :tips="logout_tips" :tips_2="logout_tips_2"></LogoutButton>
      <AboutButton back_url="Home"></AboutButton>
      <BackButton v-if="showHealthTips || showTestResult" @click="showUserInfoPage"></BackButton>
    </FabColumn>
    <ion-content class="sidebar-content">
      <div class="home-layout">
        <aside class="sidebar">
          <HomeUserList :data="users" :show_add="showAddIcon" ref="userList" @selectUser="selectUser"
            @showAddPage="showAddPage" @deleteUser="deleteUser" @searchUser="searchUser" @showAllUsers="showAllUsers">
          </HomeUserList>
        </aside>
        <main class="main">
          <HomeUserInfo v-if="showUserInfo" ref="userInfo" :data="info" :districtList="districtList" @updateUser="updateUser"
          @showTestResult="showTestResultPage" @showHealthTips="showHealthTipsPage"></HomeUserInfo>
        <HomeAddUser v-if="showAddUser" :districtList="districtList" @addUser="addUser" @mounted="addUserMounted"
          @unmounted="addUserUnmounted">
        </HomeAddUser>
        <TestResultTips v-if="showTestResult" :data="test_result" :number="info.number"></TestResultTips>
        <HomeHealthTips v-if="showHealthTips" :data="test_result" :info_ngo="info.organization"
          @showUserInfo="showUserInfoPage"></HomeHealthTips>
        <HomeStaffInfo v-if="showStaffInfo" :data="staff"></HomeStaffInfo>
        <HomeSearchNoUser v-if="showNoUser"></HomeSearchNoUser>
        </main>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonContent, IonPage } from "@ionic/vue";
import Background from "../components/common/Background";
import WhiteBackground from "../components/common/WhiteBackground";
import SidebarBackground from "../components/common/SidebarBackground";
import HomeUserList from "@/components/home/HomeUserList";
import HomeUserInfo from "@/components/home/HomeUserInfo";
import TestResultTips from "@/components/test/TestResultTips";
import HomeAddUser from "@/components/home/HomeAddUser";
import LogoutButton from "@/components/common/LogoutButton";
import common from "@/common";
import AboutButton from "@/components/common/AboutButton";
import BackButton from "@/components/common/BackButton";
import router from "@/router";
import HomeHealthTips from "@/components/home/HomeHealthTips";
import HomeStaffInfo from "@/components/home/HomeStaffInfo";
import HomeSearchNoUser from "@/components/home/HomeSearchNoUser";
import forceUpdateAlert from '@/utils/forceUpdateAlert';

export default {
  name: "Home",
  components: {
    HomeSearchNoUser,
    HomeStaffInfo,
    HomeHealthTips,
    AboutButton,
    BackButton,
    LogoutButton,
    HomeAddUser,
    TestResultTips,
    HomeUserInfo,
    HomeUserList,
    Background,
    SidebarBackground,
    WhiteBackground,
    IonPage,
    IonContent
  },
  data() {
    return {
      showUserInfo: false,
      showTestResult: false,
      showAddUser: false,
      showHealthTips: false,
      showStaffInfo: false,
      showNoUser: false,
      showAddIcon: false,

      staff: {},
      users: [],
      info: {
        id: 0,
        name: '',
        sex: 0,
        birth_year: 0,
        mobile: '',
        show_mobile: '',
        education_level: 0,
        number: 0,
        district: '',
        organization: {},
      },
      test_result: {},
      logout_tips: '',
      logout_tips_2: '是否確認登出？',

      districtList: [],
      inter: null
    }
  },
  ionViewWillEnter() {
    common.getStorage('users').then(response => {
      this.users = response;

      common.getStorage('staff').then(staff => {
        if (staff) {
          this.showStaffInfo = true;
          this.staff = staff;
        } else {
          this.$refs.userList.showFirstTitle();
          if (this.users.length === 0) {
            this.showAddUser = true;
          } else {
            this.showUserInfo = true;
          }
        }

        this.checkAddIcon();
      })
    })

    this.getUser();
    this.getDistrictList();
    this.handleAppForceUpdate();
  },
  ionViewWillLeave() {
    clearInterval(this.inter);
  },
  methods: {
    handleAppForceUpdate: function () {
      clearInterval(this.inter);
      // 每一小时检查一次更新状态
      this.inter = setInterval(async () => {
        await forceUpdateAlert();
      }, 3600000);
    },
    addUserMounted: function () {
      this.logout_tips = '您所輸入的資料將不會被保留。'
      this.logout_tips_2 = '是否確認退出新增測試者？'
    },
    addUserUnmounted: function () {
      this.logout_tips = ''
      this.logout_tips_2 = '是否確認登出？'
    },
    getDistrictList: function () {
      const loading = common.showLoading();
      common.apiGetData('/district/getDistrictList', true, loading).then(res => {
        if (res === false) {
          return false;
        }
        this.districtList = res.districts;
        common.setStorage('districts', res.districts);
      })
    },
    getUser: function () {
      const loading = common.showLoading();
      common.apiGetData('/user', true, loading).then(res => {
        if (res === false) {
          return false;
        }
        this.users = res
        common.setStorage('users', res);
      })
    },
    addUser: function (name, sex, birth_year, mobile, education_level, district_id) {
      const loading = common.showLoading();
      common.apiPostData('/user', { name, sex, birth_year, mobile, education_level, district_id }, true, loading).then(res => {
        if (res === false) {
          return false;
        }
        this.users = res.users
        common.setStorage('users', res.users)
        return res;
      }).then(res => {
        if (res === false) {
          return false;
        }
        this.checkAddIcon();
        this.$refs.userList.clickTitle(res.new_user_id);
      })
    },
    updateUser: function (id, district_id) {
      const loading = common.showLoading();
      common.apiPostData('/updateUserDistrict', { user_id: id, district_id: district_id }, true, loading).then(res => {
        if (res === false) {
          return false;
        }
        this.users.forEach((element, index) => {
          if (element.id === res.user.id) {
            const newObj = JSON.parse(JSON.stringify(this.users));
            newObj[index] = res.user;
            this.users = newObj;
            common.setStorage('users', newObj);
            common.setStorage('user_info',
              {
                id: newObj[index].id,
                number: newObj[index].number,
                mobile: newObj[index].mobile,
                show_mobile: common.splitMobile(newObj[index].mobile),
                name: newObj[index].name,
                district: newObj[index].district.full_name,
                ngo_id: newObj[index].organization.id,
                ngo_name: newObj[index].organization.name,
                ngo_address: newObj[index].organization.address,
                ngo_phone: newObj[index].organization.phone
              })
          }
        });
        router.replace('/testPrepare');
      })
    },
    deleteUser: function (id) {
      const loading = common.showLoading();
      common.apiPostData('/deleteUser', { user_id: id }, true, loading).then(res => {
        if (res === false) {
          return false;
        }
        this.users = res.users;
        common.setStorage('users', res.users);
        this.$refs.userList.clearUserName();
        return res;
      }).then(res => {
        if (res === false) {
          return false;
        }
        this.checkAddIcon();

        if (res.users.length > 0) {
          this.$refs.userList.showFirstTitle();
        } else {
          this.showAddPage();
        }
      })
    },
    searchUser: function (value) {
      common.getStorage('users').then(users => {
        const filter = users.filter(function (item) {
          return item.name.search(value) !== -1 || item.number.search(value) !== -1
        })

        this.users = filter;
        if (filter.length !== 0) {
          this.$refs.userList.showFirstTitle();
        } else {
          this.hideAllPage();
          this.showNoUser = true
        }

      })
    },
    showAllUsers: function () {
      common.getStorage('users').then(users => {
        this.users = users;
      })
    },
    selectUser: function (user_id) {
      const res = this.users.find(function (item) {
        return item.id == user_id
      })

      this.info.id = res.id;
      this.info.name = res.name;
      this.info.sex = res.sex;
      this.info.birth_year = res.birth_year;
      this.info.mobile = res.mobile;
      this.info.show_mobile = common.splitMobile(res.mobile);
      this.info.education_level = res.education_level;
      this.info.number = res.number;
      this.info.district = res.district !== null ? res.district.full_name : '';
      this.info.organization = res.organization !== null ? res.organization : '';

      this.hideAllPage();
      this.showUserInfo = true;

      this.getTestResult();
    },
    showUserInfoPage: function () {
      this.hideAllPage();
      this.showUserInfo = true;
    },
    showAddPage: function () {
      this.hideAllPage();
      this.showAddUser = true;
      this.$refs.userList.clearUserName();
    },

    getTestResult: function () {
      common.apiGetData('/getTestResult?user_id=' + this.info.id, true).then(res => {
        if (res === false) {
          return false;
        }
        this.test_result = res;
      })
    },

    showTestResultPage: function () {
      if (this.test_result.no_result !== undefined) {
        return common.showAlert('請先進行一次測試。', '沒有紀錄');
      }
      else {
        this.hideAllPage();
        this.showTestResult = true;
      }
    },
    showHealthTipsPage: function () {
      this.hideAllPage();
      this.showHealthTips = true;
    },
    hideAllPage: function () {
      this.showUserInfo
        = this.showAddUser
        = this.showHealthTips
        = this.showTestResult
        = this.showStaffInfo
        = this.showNoUser
        = false;
    },
    checkAddIcon: function () {
      if (Object.keys(this.staff).length !== 0 || this.users.length < 10) {
        this.showAddIcon = true;
      } else {
        this.showAddIcon = false;
      }
    }
  }
}
</script>

<style scoped>
.home-layout {
  position: absolute;
  inset: 0;
  display: flex;
}

.sidebar {
  position: relative;
  flex: 0 0 20%;
  height: 100%;
}

.main {
  position: relative;
  box-sizing: border-box;
  width: 70%;
  height: calc(100% - 4rem);
  margin: 2rem 5% 2rem 5%;
  /* overflow-y: scroll; */
}

@media (max-width: 720px) {
  .main {
    height: calc(100% - 2rem);
    margin: 1rem 5% 1rem 5%;
  }
}

</style>
